import apiValidation from '../validation/ApiRespValidation'
import { logError } from '../../logs/ErrorLoger'
import generalMapper from '../../models/GeneralMapper'

/*const options = (method, Authorization, bodyData) => {
  const headers = { 'Content-Type': 'application/json' }
  headers.Authorization = 'Bearer ' + Authorization
  headers.Canal = global.CANAL
  let requestOptions
  if (method === 'POST') {
    requestOptions = {
      method,
      headers,
      body: JSON.stringify(bodyData)
    }
  } else {
    requestOptions = {
      method,
      headers
    }
  }
  return requestOptions
}*/

const options = (method, Authorization, bodyData) => {
  const headers = { 'Content-Type': 'application/json' }
  if (Authorization) headers.Authorization = 'Bearer ' + Authorization
  if (global.CANAL) headers.Canal = global.CANAL
  const requestOptions = { method, headers }
  if (method === 'POST') requestOptions.body = JSON.stringify(bodyData)
  return requestOptions
}

const handleFetchResponse = async (resp) => {
  if (resp.status !== 200) {
    if (!resp.error) {
      const errorData = apiValidation.getHttpError(resp.status)
      await logError(errorData.message, 1)
      return errorData
    }

    const json = await resp.json()

    if (json?.error) {
      const errorData = apiValidation.getHttpError(json?.code || 500)
      await logError(errorData.message, 1)
      return errorData
    }
  } else {
    if (resp.status === 200 && resp.error) {
      return generalMapper.postResponseMapper(resp)
    } else {
      return await resp.json()
    }
  }
}

const handleFetchSaveResponse = async (resp) => {
  const json = await resp.json()

  if (resp.status !== 200) {
    if (json?.message) {
      return {
        error: true,
        message: json.message,
        variant: json.variant || 'warning',
        data: json.data || []
      }
    }

    const errorData = apiValidation.getHttpError(resp.status)

    await logError(errorData.message, 1)

    return errorData
  }

  return json
}

const requestValidation = {
  options,
  handleFetchResponse,
  handleFetchSaveResponse
}

export default requestValidation
